<template>
  <div>
    <div class="bigbox">
      <div class="title">
        <div>
          <!-- <div class="eng">National Stores</div> -->
          <div class="text">全国门店</div>
          <div class="title-icon"></div>
        </div>
      </div>
      <div class="citybar">
        <div class="city">省/市：</div>
        <ul class="choose">
          <li
            class="choose-item"
            v-for="(item, index) in province"
            :key="index"
            :class="{ active: index == active }"
            @click="onclick(item, index)"
          >
            <a>{{ item.areaName }}</a>
          </li>
        </ul>
      </div>

      <div class="citybars citybar">
        <div class="city">区：</div>
        <ul class="choose">
          <li
            class="choose-item"
            :class="{ active: -1 == active1 }"
            @click="onclick1(item, -1)"
          >
            <a>不限</a>
          </li>
          <li
            class="choose-item"
            v-for="(item, index) in distinguish"
            :key="index"
            :class="{ active: index == active1 }"
            @click="onclick1(item, index)"
          >
            <a>{{ item.areaName }}</a>
          </li>
        </ul>
      </div>
      <div class="store-title">
        <span class="store-head"
          > <span class="number">{{ count }}</span
          >家门店</span
        >
      </div>
      <div class="store-box-icon"></div>
      <Storeitem :storelist="storelist" />
    </div>
  </div>
</template>

<script>
import Storeitem from "@/components/Store_item";
export default {
  name: "NationalStores",
  data() {
    return {
      province: [],
      distinguish: [],
      active: 0,
      active1: -1,
      storelist: [],
      count: 0,
    };
  },
  components: {
    Storeitem,
  },
  mounted() {
    this.$http.post("/index/store/tarList", {}).then((res) => {
      this.province = res.data.data.city;
      this.distinguish = res.data.data.county;
      this.$http
        .post("/index/store/list", {
          city: this.province[0].cid,
        })
        .then((ress) => {
          this.storelist = ress.data.data;
          this.count = ress.data.count;
          console.log(ress);
        });
    });
  },
  methods: {
    onclick(item, i) {
      this.active = i;
      this.$http
        .post("/index/store/getCounty", {
          city: item.cid,
        })
        .then((res) => {
          this.distinguish = res.data.data;
          this.active1 = -1;
          this.$http
            .post("/index/store/list", {
              city: item.cid,
            })
            .then((ress) => {
              this.storelist = ress.data.data;
              this.count = ress.data.count;
              console.log(ress);
            });
        });
    },
    onclick1(item, i) {
      this.active1 = i;
      console.log(i != -1);
      let list = "";
      if (i != -1) {
        list = item.cid;
      }
      this.$http
        .post("/index/store/list", {
          city: this.province[this.active].cid,
          county: list,
        })
        .then((ress) => {
          this.storelist = ress.data.data;
          this.count = ress.data.count;
          console.log(ress);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.active {
  background: #00a4a7 !important;
  a {
    color: white !important;
  }
}
li {
  list-style: none;
}
a {
  text-decoration: none;
}
a,
a:visited,
a:link,
a:hover {
  color: black;
}
.bigbox {
  margin: 110px auto 0px;
  padding-bottom: 80px;
  // height: 1180px;
  width: 1220px;
  @media (min-width: 1024px) and (max-width: 1366px) {
    width: 1120px;
  }
  .title {
    display: flex;
    justify-content: center;
    .eng {
      text-align: center;
      font-size: 24px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #33333380;
    }
    .text {
      text-align: center;
      margin-top: 16px;
      font-size: 36px;
      @media (min-width: 1024px) and (max-width: 1366px) {
        font-size: 30px;
      }
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #333333;
    }
    .title-icon {
      margin-top: 16px;
      width: 272px;
      height: 8px;
      background: linear-gradient(
        270deg,
        rgba(0, 164, 167, 0) 0%,
        #00a4a7 49%,
        rgba(0, 164, 167, 0) 100%
      );
    }
  }

  .citybar {
    margin-top: 60px;
    display: flex;
    .city {
      width: 110px;
      text-align: right;
      font-size: 30px;
      @media (min-width: 1024px) and (max-width: 1366px) {
        font-size: 24px;
        width: 85px;
      }
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #333333;
    }
    .choose {
      width: auto;
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      .choose-item {
        height: 100%;
        width: auto;
        margin-right: 27px;
        cursor: pointer;
        padding: 8px 13px;
        box-sizing: border-box;
        font-size: 20px;
        @media (min-width: 1024px) and (max-width: 1366px) {
          font-size: 18px;
        }
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;

        border-radius: 4px 4px 4px 4px;
        color: #333333;
      }
    }
  }
  .citybars {
    margin-top: 40px;
  }
  .store-title {
    margin-top: 40px;
    .store-head {
      font-size: 20px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      .number {
        color: #00a4a7;
        font-size: 60px;
        @media (min-width: 1024px) and (max-width: 1366px) {
          font-size: 50px;
        }
        font-weight: bold;
        font-family: Source Han Sans CN-Regular;
      }
    }
  }
  .store-box-icon {
    margin-top: 2px;
    width: 100%;
    height: 4px;
    background: linear-gradient(90deg, #00a4a7 0%, rgba(0, 164, 167, 0) 100%);
    border-radius: 0px 0px 0px 0px;
  }
}

@media (max-width: 768px) {
  li {
    list-style: none;
  }
  a {
    text-decoration: none;
  }
  a,
  a:visited,
  a:link,
  a:hover {
    color: black;
  }
  .bigbox {
    margin: 20px auto 0px;
    padding-bottom: 40px;
    // height: 1180px;
    width: 100%;
    .title {
      display: flex;
      justify-content: center;
      .eng {
        text-align: center;
        font-size: 24px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #33333380;
      }
      .text {
        text-align: center;
        margin-top: 10px;
        font-size: 26px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #333333;
      }
      .title-icon {
        margin-top: 16px;
        width: 272px;
        height: 8px;
        background: linear-gradient(
          270deg,
          rgba(0, 164, 167, 0) 0%,
          #00a4a7 49%,
          rgba(0, 164, 167, 0) 100%
        );
      }
    }

    .citybar {
      display: flex;
      width: 90%;
      margin: 0 auto;
      margin-top: 20px;
      .city {
        width: 20%;
        text-align: right;

        // align-items: center;
        margin-top: 18px;
        // text-align: center;
        font-size: 18px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #333333;
      }
      .choose {
        text-align: center;
        width: 80%;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        .choose-item {
          // padding: 0 20px 10 20px;
          height: 100%;
          width: auto;
          margin: 10px 10px;
          cursor: pointer;
          padding: 8px 8px;
          box-sizing: border-box;
          font-size: 16px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;

          border-radius: 4px 4px 4px 4px;
          color: #333333;
        }
      }
    }
    .citybars {
      margin-top: 20px;
      text-align: right;
    }
    .store-title {
      width: 90%;
      margin: 0 auto;
      margin-top: 20px;
      .store-head {
        font-size: 20px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        .number {
          color: #00a4a7;
          font-size: 30px;
          font-weight: bold;
          font-family: Source Han Sans CN-Regular;
        }
      }
    }
    .store-box-icon {
      margin-top: 2px;
      width: 90%;
      margin: 0 auto;
      height: 4px;
      background: linear-gradient(90deg, #00a4a7 0%, rgba(0, 164, 167, 0) 100%);
      border-radius: 0px 0px 0px 0px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/NationalStores.vue